import { render, staticRenderFns } from "./CeliacBlock.vue?vue&type=template&id=5719fd3e&scoped=true"
import script from "./CeliacBlock.vue?vue&type=script&lang=js"
export * from "./CeliacBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5719fd3e",
  null
  
)

export default component.exports